import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

import './js/main'
import './js/navigation'
// import './js/mega-menu-logic'
import './js/skip-link-focus-fix'
import './js/testimonials'